import React, {useState, useEffect} from 'react'
import { connect } from 'react-redux';
import styles from "./Report.module.css";
import Table from './Table'
import Handler from './Handler'
import {
  getReport, 
  setReport, 
  getYears, 
  getSpecialty, 
  schoolYear, 
  getCathedra, 
  getGroup, 
  getPeriod, 
  getSchema, 
  trashReport, 
  getCalculation, 
  trashCalculation, 
  getDigitalPortrait, 
  trashSchema, 
  trashCafedra, 
  trashGroup, 
  trashPortrait,
  getMinMax
} from '../../actions/report'
import {MONTHS} from '../../utils/const'
import { Spinner } from 'react-bootstrap';
import DigitalPortrait from './DigitalPortrait'

/**
 * 
 * @DIGITAL_RATING
 * РЕЙТИНГ-РАСПРЕДЕЛЕНИЕ И ЦИФРОВОЙ ПОРТРЕТ
 */
const Report = ({
  data, 
  loading, 
  getReport, 
  setReport, 
  getSpecialty, 
  getCathedra, 
  schoolYear, 
  special, 
  scy, 
  cathedra, 
  trashCafedra,
  getGroup, 
  groups, 
  period, 
  getPeriod, 
  schema, 
  getSchema,
  trashSchema,  
  getCalculation,
  ratingCalc, 
  trashCalculation,
  portrait,
  getDigitalPortrait,
  trashGroup,
  trashPortrait,
  minMaxRating,
  getMinMax,
  state,
  loadingRadar
  }) => {
  
  const [faculty, setFaculty] = useState(localStorage.getItem('fak') || null);
  const [schemas, setSchema] = useState(localStorage.getItem('schema') || null);
  const [year, setYear] = useState(localStorage.getItem('year') || null);
  const [month, setMonth] = useState(localStorage.getItem('period') || null);
  const [cathedras, setCathedra] = useState(localStorage.getItem('kaf') || null);
  const [group, setGroup] = useState(localStorage.getItem('grop') || null);
  const [schemaType, setSchemaType] = useState(false);
  const [portraits, setPortraits] = useState(null);
  const [mid, setMid] = useState(null);

  const [isRadial, setIsRadial] = useState(false);
  const [isCompare, setIsCompare] = useState(false);
  
  const scrollRef = React.useRef(null);

  useEffect(() => {
    getSpecialty();
    schoolYear();
    trashCalculation();
    setPortraits(null);


    return () => {
      trashPortrait();
    }
  }, [])
  
  useEffect(() => {
    if (year) {
      getPeriod(year);
      getSchema(year);
    } else {
      trashSchema();
    }
  }, [year]);

  // при выбранном факультете кафедры грузит эффект в Handler
  useEffect(() => {
    !faculty && getCathedra(0);
  }, [faculty]);

  // единственное место загрузки групп — иначе запрос дублируется
  useEffect(() => {
    if (year) {
      getGroup(cathedras || 0, faculty || 0, year, '', state['Рейтинг распределение и цифровой портрет. Администратор.']);
    } else {
      trashGroup();
    }
  }, [cathedras, faculty, year]);


useEffect(() => {
  portrait && portrait.length && setPortraits(portrait);
}, [portrait])

  const handleGetTable = () => {
    if (month && month.length &&
        group && group.length &&
        schemas && schemas.length &&
        year && year.length) {
          setSchemaType(false);
          setPortraits(null);
          setIsCompare(null);
          getCalculation('rating_calc_details', schemas, group, year, month, '', 0);

    } else if (localStorage.getItem('schema') && localStorage.getItem('year') && localStorage.getItem('period') && localStorage.getItem('grop')) {
          setSchemaType(false);
          setPortraits(null);
          setIsCompare(null);
          getCalculation('rating_calc_details', localStorage.getItem('schema'), localStorage.getItem('grop'), localStorage.getItem('year'), localStorage.getItem('period'), '', 0);
    } else {
      setSchemaType(false);
      setPortraits(null);
      setIsCompare(null);
      getCalculation('rating_calc_details', schemas != null ? schemas?.[0] : schemas || 0, group === null ? 0 : group, (year === undefined || year === null) ? 0 : year,  (month !== undefined || month !== null)  ? month?.[0] : month || 0, '', 0);
    }

  }

  const handleTrash = () => {
    setYear(null);
    setFaculty(null);
    trashCalculation();
    setPortraits(null);
    localStorage.removeItem('fak');
    localStorage.removeItem('schema');
    localStorage.removeItem('year');
    localStorage.removeItem('period');
    localStorage.removeItem('kaf');
    localStorage.removeItem('grop');
  }

  const handleMore = () => {
    getCalculation('rating_calc_details', schemas, group, year, month, '', 1);
    setSchemaType(prev => !prev);
    setPortraits(null);
    setIsCompare(null);
  }

  const handleLess = () => {
    getCalculation('rating_calc_details', schemas, group, year, month, '', 0);
    setSchemaType(prev => !prev);
    setPortraits(null);
    setIsCompare(null);
  }

  useEffect(() => {
    if (!localStorage.getItem('year')) {
      setSchema(null);
      setMonth(null);
    }
  }, [year])
  
  useEffect(() => {
    if (!localStorage.getItem('kaf')) {
      setCathedra(null);
    }
  }, [faculty])

  useEffect(() => {
    if (!localStorage.getItem('kaf') || !localStorage.getItem('year')) {
      setGroup(null);
    }
  }, [cathedras, year])

  const handleCompare = () => {
    setIsCompare(true);
    if (scrollRef !== null && !loading) {scrollRef.current.scrollIntoView({ behavior: "smooth" })};
  }

  if (state['Рейтинг распределение и цифровой портрет. Администратор.'] == 'Нет' && state['Рейтинг распределение и цифровой портрет.'] == 'Нет') {
    return <div className="captions h1">Доступ закрыт</div>;
  }
console.log(ratingCalc, 'ratingCalc')
  return (
    <div className={styles.wrapperReset}>
        <div className="captions h1">Рейтинг-распределение и цифровой портрет</div>
        
        <div className={styles.wrapperHandAndBut}>
          <div>
            <div className={styles.wrapperHandles}>
              <Handler name='Год' localName='year' handle={year} setHandle={setYear} options={scy} trashGroup={trashGroup} trashCafedra={trashCafedra} getReport={getReport} data={data}/>
              <Handler name='Схема' localName='schema' handle={schemas} setHandle={setSchema} trashGroup={trashGroup} trashCafedra={trashCafedra} options={schema} getReport={getReport} data={data}/>
              <Handler name='Период (месяц)' localName='period' handle={month} setHandle={setMonth} trashGroup={trashGroup} trashCafedra={trashCafedra} options={MONTHS} getReport={getReport} data={data} period={period}/>
            </div>
            <div className={styles.wrapperHandles2}>
              <Handler name='Факультет' localName='fak' handle={faculty} getCathedra={getCathedra} trashGroup={trashGroup} trashCafedra={trashCafedra} setHandle={setFaculty} options={special} getReport={getReport} data={data}/>
              <Handler name='Кафедра' localName='kaf' handle={cathedras} setHandle={setCathedra} trashGroup={trashGroup} trashCafedra={trashCafedra} options={cathedra} getReport={getReport} data={data}/>
              <Handler name='Группа' localName='grop' handle={group} setHandle={setGroup} trashGroup={trashGroup} trashCafedra={trashCafedra} options={groups} getReport={getReport} data={data}/>
            </div>
          </div>

        <div className={styles.buttonsReset}>
          {// ЧТОБЫ НЕ ЛОМАТЬ ЗАПРОС http://10.120.7.20/lms/api/v1.0/studium/rating_calc_details/4/0/2025-1-01/1
            year && schema && month &&
        <button className={styles.buttonReset} onClick={handleGetTable}>Обновить</button>
          }
        <button className={styles.buttonResetTrash} onClick={handleTrash}>Сброс</button>
        </div>
        </div>

        
        {
          !loading && ratingCalc && ratingCalc.length > 0 &&
          <div className={styles.wrapperTableReset}>
            <Table
            setReport={setReport}
            getCalculation={getCalculation}
            getDigitalPortrait={getDigitalPortrait}
            ratingCalc={ratingCalc}
            year={year}
            group={group}
            groups={groups}
            schemas={schemas}
            schemaType={schemaType}
            scrollRef={scrollRef}
            loading={loading}
            setIsRadial={setIsRadial}
            setIsCompare={setIsCompare}
            isCompare={isCompare}
            month={month}
            mid={mid}
            setMid={setMid}
            getMinMax={getMinMax}
            setPortraits={setPortraits}
            />
          </div>
        }

        {
          ratingCalc && ratingCalc.length > 0 &&
          <button className={styles.buttonReset} onClick={!schemaType ? handleMore : handleLess}>{!schemaType ? 'Подробнее' : 'Вернуться' }</button>
        }

        {
          ratingCalc && ratingCalc.length > 0 && schemaType ?
          <button className={styles.buttonReset} onClick={handleCompare}>Сравнительная диаграмма</button>
          :
          ''
        }
        
        {
          loading && 
          <div className="text-center">
            <Spinner animation="border" role="status">
              <span className="sr-only">Загрузка...</span>
            </Spinner>
          </div>
        }

        {
          (!ratingCalc || !ratingCalc.length > 0) && !loading &&
          <div className={styles.hint}>
            <i>
            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M12 6a3.939 3.939 0 0 0-3.934 3.934h2C10.066 8.867 10.934 8 12 8s1.934.867 1.934 1.934c0 .598-.481 1.032-1.216 1.626a9.208 9.208 0 0 0-.691.599c-.998.997-1.027 2.056-1.027 2.174V15h2l-.001-.633c.001-.016.033-.386.441-.793.15-.15.339-.3.535-.458.779-.631 1.958-1.584 1.958-3.182A3.937 3.937 0 0 0 12 6zm-1 10h2v2h-2z"></path><path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path></svg>
            </i><p>Задайте параметры таблицы</p></div>
        }
        <div className={styles.digitalWrap} ref={scrollRef}>
        {((month && month.length && group && group.length && year && year.length && portraits && portraits.length) || 
        (localStorage.getItem('year') && localStorage.getItem('period') && localStorage.getItem('grop') && portraits && portraits.length && isCompare)||
        (month && month.length && group && group.length && year && year.length && ratingCalc && ratingCalc.length) || 
        (localStorage.getItem('year') && localStorage.getItem('period') && localStorage.getItem('grop') && ratingCalc && ratingCalc.length && isCompare)) 
        ? <DigitalPortrait data={!isCompare ? portraits : ratingCalc} schemaType={schemaType} isRadial={isRadial} isCompare={isCompare} setIsCompare={setIsCompare} ratingCalc={ratingCalc} mid={mid} minMaxRating={minMaxRating} loadingRadar={loadingRadar}/>
        :
        ''}
        </div>

    </div>
  )
}

const mapStateToProps = (state) => ({
  data: state.report.report,
  loading: state.report.loading,
  years: state.report.years,
  special: state.report.special,
  scy: state.report.scy,
  cathedra: state.report.cathedra,
  groups: state.report.groups,
  period: state.report.period,
  schema: state.report.schema,
  ratingCalc: state.report.ratingCalc,
  portrait: state.report.portrait,
  digitalLoading: state.report.digitalLoading,
  minMaxRating: state.report.minMaxRating,
  loadingRadar: state.report.loadingRadar,
  state: state.auth.access_modes['Режимы']
});

export default connect(mapStateToProps, { 
  getReport, 
  setReport, 
  getYears, 
  getSpecialty, 
  schoolYear, 
  getCathedra, 
  getGroup, 
  getPeriod, 
  getSchema, 
  trashReport, 
  getCalculation, 
  trashCalculation, 
  getDigitalPortrait, 
  trashSchema, 
  trashCafedra, 
  trashGroup, 
  trashPortrait,
  getMinMax
})(Report);
